import { render, staticRenderFns } from "./SponsoredRecommendationImageNewPage.vue?vue&type=template&id=2e98ef0a&scoped=true"
import script from "./SponsoredRecommendationImageNewPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationImageNewPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationImageNewPage.vue?vue&type=style&index=0&id=2e98ef0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e98ef0a",
  null
  
)

export default component.exports